export default __webpack_public_path__ + "static/media/sports-rebate-ico.00c7fab0.svg";